import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardTitle,
  CardColumns,
  CardBody,
  CardSubtitle,
  CardText,
  Button,
} from 'reactstrap';
import { useHistory, NavLink } from 'react-router-dom';
import './CollectionsPage.scss';
import FixedTitleMultipleSelect from '../../widgets/FixedTitleMultipleSelect/FixedTitleMultipleSelect';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import store from '../../redux/store';
import config from '../../config';

import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import { getDetailDataList } from '../../redux/modules/detailDataList/action';
import { customApi, debounce } from '../../utils/UtilsClass';
import contentLoadingGif from '../../assets/images/common/content-loading.gif';
import NoMatch from '../NoMatch';
import UnderConstruction from '../../components/UnderConstruction';

const Collections = (props) => {
  const {
    i18n,
    collectionsDetail,
    season,
    brand,
    collectionsData,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;

  const COLLECTION_DATA = 'COLLECTION_DATA';
  const collectionsDetailData = collectionsDetail[COLLECTION_DATA] || {};

  const debouncePageLoading = useDebounceLoading(collectionsData);
  const jsLoading = useDelayJsLoadiing(collectionsData);
  const notFound = useNotFound(collectionsData);
  // const debouncePageLoading = useDebounceLoading(collectionsData);
  // const jsLoading = useDelayJsLoadiing(collectionsData);

  usePage(null, config.pageType.collectionsPage, null);
  useAdGlare(i18n.locale, siteConfig, collectionsData, enableAdGlare.status);
  useUnmountResetPage();

  const siteConfigData = siteConfig.data || {};
  const { defaultLanguage } = siteConfigData;

  const { translations = {}, locale = defaultLanguage } = i18n || {};
  // const t = translations[locale] || {};

  const { data = [] } = collectionsData || {};
  const content = Array.isArray(data) && data.length > 0 ? data[0] : {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // HelmetMeta
  const { topMetadata = {} } = content || {};
  const publishDate = topMetadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    collectionsData,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, content, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const curLang = i18n.locale;
  const collectionsDetailArrays = Array.isArray(collectionsDetailData?.data)
    ? collectionsDetailData.data
    : [];

  const seasonData = season.data || {};
  const brandData = brand.data || {};

  const seasonTitle = {
    sc: '季度',
    en: 'SEASON',
    tc: '季度',
  };

  const brandTitle = {
    sc: '品牌',
    en: 'BRAND',
    tc: '品牌',
  };

  const seasonOptions =
    seasonData[curLang]?.season_category_config?.categories
      ?.slice()
      .reverse()
      .map((item, index) => ({
        value: item.season_category_id,
        label: item.season_category_name,
      })) ?? [];

  const brandOptions =
    brandData[curLang]?.brand_category_config?.categories?.map((item, index) => ({
      value: item.brand_category_id,
      label: item.brand_category_name,
    })) ?? [];

  const [selectSeason, setSelectSeason] = useState([]);
  const [selectBrand, setSelectBrand] = useState([]);

  const start = 0;
  const max = 16;

  const currentPageRef = useRef(1);
  const totalRef = useRef(max);
  const [loadedNewDatas, setLoadedNewDatas] = useState([]);
  const [loadedGif, setLoadedGif] = useState(false);

  useEffect(() => {
    setLoadedNewDatas([]);
    currentPageRef.current = 1;
    totalRef.current = max;

    store.dispatch(
      getDetailDataList(
        COLLECTION_DATA,
        null,
        config.pageType.collectionsDetailPage,
        [
          'displayStatus:true',
          selectSeason.map((season) => `(season:${season})`).join(' OR '),
          selectBrand.map((brand) => `(brand:${brand})`).join(' OR '),
        ],
        start,
        max,
        'sequence',
        true,
      ),
    );
  }, [selectSeason, selectBrand]);

  const selectSeasonFun = (seasons) => {
    setSelectSeason(seasons);
  };

  const selectBrandFun = (brands) => {
    setSelectBrand(brands);
  };

  // const resetBrandOptions = useMemo(() => {
  //   const mergedData = [...collectionsDetailArrays, ...loadedNewDatas];
  //   if (selectSeason.length > 0) {
  //     const newBrandArray =
  //       mergedData
  //         ?.filter((item) => selectSeason.includes(item.collection.season))
  //         ?.map((item) => item.collection?.brand ?? '') ?? [];

  //     return brandOptions.filter((item) => newBrandArray.includes(item.value));
  //   } else {
  //     return brandOptions;
  //   }
  // }, [selectSeason, brandOptions, collectionsDetailArrays,loadedNewDatas]);

  const MemoCard = React.memo(({ item, curLang }) => (
    <Card className="collections-card">
      <div className="card-container">
        <NavLink
          to={(location) => ({
            ...location,
            pathname: `${config.routePathTo}/${curLang}/collections/${item.metadata.id}`,
            search: `?p1=${item.collection.season}&p2=${item.collection.brand}`,
          })}
        >
          <CardImg src={item.collection.thumbnail_upload} alt="error" />
          <div className="card-overlay">
            <div className="card-overlay-text">
              <div className="title">{item[curLang].collection_detail.collection_title}</div>
              <div className="designer">{item.collection.brand}</div>
            </div>
          </div>
        </NavLink>
      </div>
    </Card>
  ));

  const memoizedCardEle = useMemo(() => {
    const mergedData = [...collectionsDetailArrays, ...loadedNewDatas];
    return mergedData?.map((item) => (
      <MemoCard
        key={`${item.metadata.id}${item.collection.season}${item.collection.brand}`}
        item={item}
        curLang={curLang}
      />
    ));
  }, [collectionsDetailArrays, loadedNewDatas, curLang]);

  const pageTitle = {
    sc: '时装系列',
    en: 'COLLECTIONS',
    tc: '時裝系列',
  };

  const handleScroll = useCallback(async () => {
    // console.log('data---scrollHeight',document.documentElement.scrollHeight);
    // console.log('data---scrollTop', document.documentElement.scrollTop);
    // console.log('data---innerHeight', window.innerHeight);
    // console.log('data---scrollY', window.scrollY);
    // const scrollBottom = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;

    const newStart = max * currentPageRef.current;

    if (newStart <= totalRef.current) {
      if (
        document.documentElement.scrollTop + window.innerHeight >
        document.documentElement.scrollHeight - 300
      ) {
        console.log('data---trigger scroll');

        try {
          console.log('data---selectSeason', selectSeason);
          console.log('data---selectBrand', selectBrand);

          setLoadedGif(true);
          const response = await customApi(
            null,
            config.pageType.collectionsDetailPage,
            [
              'displayStatus:true',
              selectSeason.map((season) => `(season:${season})`).join(' OR '),
              selectBrand.map((brand) => `(brand:${brand})`).join(' OR '),
            ],
            newStart,
            max,
            'sequence',
            true,
          );

          setLoadedNewDatas((prev) => [...prev, ...response.data]);
          totalRef.current = response.total;
          currentPageRef.current += 1;
        } catch (error) {
          console.error('Loaded New Datas error:', error);
        }
        setLoadedGif(false);
      }
    }
  }, [max, selectSeason, selectBrand]);

  useEffect(() => {
    const debouncedScroll = debounce(handleScroll, 500);
    window.addEventListener('scroll', debouncedScroll);

    return () => {
      window.removeEventListener('scroll', debouncedScroll);
      debouncedScroll.cancel();
    };
  }, [handleScroll]);

  const mainContent = (
    <div className="collections-page">
      <Container>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <PageTitle
              title={
                collectionsDetail?.[config.pageType.collectionsPage]?.data?.[0]?.[locale]?.setting
                  ?.title
              }
              isFirst
            />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="dropdown-col">
            <div className="c1">
              <FixedTitleMultipleSelect
                options={seasonOptions}
                title={seasonTitle[curLang]}
                selectFun={selectSeasonFun}
              />
            </div>
            <div className="c2">
              <FixedTitleMultipleSelect
                options={brandOptions}
                title={brandTitle[curLang]}
                selectFun={selectBrandFun}
              />
            </div>
          </Col>
        </Row>
        <div className="collections-card-grid">{memoizedCardEle}</div>
        {loadedGif && (
          <div style={{ textAlign: 'center', paddingTop: '20px' }}>
            <img src={contentLoadingGif} />
          </div>
        )}
      </Container>
    </div>
  );

  const pageEle = notFound ? (
    <NoMatch />
  ) : (
    <>
      {under_construction && <UnderConstruction />}
      <h1 className="access-elem">{seo.seo_title}</h1>
      {!under_construction && mainContent}
      {!under_construction && (
        <HelmetScript
          helmetScriptCallBack={helmetScriptCallBack}
          extraHead={extra_head}
          jsScript={js_script_block}
        />
      )}
    </>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  collectionsDetail: state.detailDataList,
  collectionsData: state.generalPage,
  season: state.season,
  brand: state.brand,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Collections);

export { Collections as CollectionsComponent }; // <- For component Unit Test
export default connectStore;
